import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "app-page" }
const _hoisted_2 = { class: "filter form" }
const _hoisted_3 = {
  class: "item",
  "data-size": "big"
}
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  class: "item",
  "data-cta": "multi"
}
const _hoisted_6 = { class: "cta" }
const _hoisted_7 = {
  key: 0,
  class: "cta"
}
const _hoisted_8 = { class: "item-list" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "top" }
const _hoisted_11 = { class: "date" }
const _hoisted_12 = { class: "codes" }
const _hoisted_13 = {
  key: 0,
  class: "code"
}
const _hoisted_14 = { class: "code" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "lable" }
const _hoisted_17 = { class: "box-image" }
const _hoisted_18 = {
  key: 0,
  class: "approved-item"
}
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = {
  key: 2,
  class: "placeholder"
}
const _hoisted_21 = {
  key: 0,
  class: "no-item"
}

import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProcessList',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const localizer = Localizer;
const searchText = ref<string | null>(null);
const isLoading = ref(false);
const isSearch = ref(false);
const assets = ref<any[]>([]);

onMounted(async () => {
	if (route.query.searchtext) {
		searchText.value = <string>route.query.searchtext;
		await getAssetList();
	} else if (JSON.parse(window.sessionStorage.getItem("ProcessSearch"))) {
		searchText.value = (JSON.parse(window.sessionStorage.getItem("ProcessSearch"))).searchText;
		if (searchText.value) {
			await getAssetList();
		}
	}
});

async function getAssetList() {
	router.push({ path: window.location.pathname, query: { searchtext: searchText.value } }).catch(() => { });

	isLoading.value = true;
	isSearch.value = true;

	try {
		let response = (await Axios.post((<any>window).App.routes.PrivateArea_Process_GetAssetList, { searchText: searchText.value })).data;
		window.sessionStorage.setItem("ProcessSearch", JSON.stringify({ searchText: searchText.value }));

		assets.value = response;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 400) {
				let validationErrors = FormHelper.getValidationErrors(error.response.data);
				if (validationErrors.length !== 0) {
					store.dispatch("accountAreaToastStore/onAddToast", { message: validationErrors[0].message, type: "Error" });
				}
			}
		}
	}

	isLoading.value = false;
}

function resetSearch() {
	assets.value = [];
	searchText.value = null;
	isSearch.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "textbox",
          type: "text",
          placeholder: _unref(localizer).get('PrivateArea.Common.ProcessPage_SearchBox_Placeholder'),
          onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (getAssetList()), ["enter"])),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event))
        }, null, 40, _hoisted_4), [
          [_vModelText, searchText.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (getAssetList())),
            "data-size": "small"
          }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProcessPage_SearchBox_Button")), 1)
        ]),
        (isSearch.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "button",
                "data-type": "link",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (resetSearch()))
              }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProjectDetail_FilterBox_ResetFilters")), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assets.value, (asset, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: index,
          href: asset.linkUrl,
          class: "item"
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(asset.dateItem), 1),
            _createElementVNode("div", _hoisted_12, [
              (asset.projectCode)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Ord. " + _toDisplayString(asset.projectCode), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_14, "Cod. " + _toDisplayString(asset.code), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(asset.title), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            (asset.isApproved)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "icon fastic-check" }, null, -1)),
                  _createTextVNode(_toDisplayString(_unref(localizer).get("PrivateArea.Common.AssetApproved")), 1)
                ]))
              : _createCommentVNode("", true),
            (asset.imageUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: asset.imageUrl,
                  loading: "lazy",
                  width: "405",
                  height: "303",
                  alt: asset.title
                }, null, 8, _hoisted_19))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("div", { class: "content" }, [
                    _createElementVNode("span", { class: "icon fastic-image" })
                  ], -1)
                ]))]))
          ])
        ], 8, _hoisted_9))
      }), 128)),
      (isSearch.value && assets.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProjectDetail_NoAssets")), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})